import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SystemAlertService } from '../learner/system-alert/system-alert.service';
import { BaseService } from '../shared-service/base.service';
import { HttpClient } from '@angular/common/http';
declare var $: any;



@Injectable()
export class NotificationRouteService {
	
	private storageRouteStatusKey: PropertyKey = 'RouteStatusKey';
	private subMenuArray: Array<any> = [];

	constructor(private router: Router, private bs: BaseService, private systemAlertService: SystemAlertService) {
		this.bs.log('info', "Loaded NotificationRouteService");
		let menuLength = this.bs.menu['MenuItems'].length;
		for (let i = 0; i < menuLength; i++) {
			let subMenuLength = this.bs.menu['MenuItems'][i]['subMenuItems'].length;
			for (let j = 0; j < subMenuLength; j++) {
				this.subMenuArray.push(this.bs.menu['MenuItems'][i]['subMenuItems'][j]['Action']);

			}
		}

	}

	routeNotificationItems(RouteItem: Object|any) {
		this.bs.log('info', RouteItem['ItemId']);
		let itemType = RouteItem['ItemType'];
		let ItemId = RouteItem['ItemId'];
		let actionName = RouteItem['ActionName'];
		let paramObj = {};

		this.bs.isTrainingHistory = false;

		if (itemType == "ANN") {
			paramObj = {
				AnnouncementId: ItemId
			}
		}
		else if (itemType == "DF") {
			if (this.subMenuArray.indexOf('/learner/conversation/container') > -1) {
				paramObj = {
					ItemId: ItemId
				}
				this.systemAlertService.getPublicDFRouteStatusFromServer(paramObj, this.storageRouteStatusKey).then((data) => {
					if (data == "A") {
						this.routeTo(this.bs.loadModulePath('cnvrstn_mdl'), { id: ItemId, date: new Date().getTime() }, 'D');
					}
					else if (data == "M") {
						alert("Item has been expired");
						return false;
					}
				},
					(data) => {
						this.bs.log('info', 'Error in getting list');
					});
			}
			else {
				alert("Access denied - You are not authorized to access this notification.")
				return false;
			}
		}

		else if (itemType == "SRV") {
			if (this.subMenuArray.indexOf('learner/survey/container') > -1) {
				paramObj = { ItemId: ItemId }
				this.systemAlertService.getPublicSRVRouteStatusFromServer(paramObj, this.storageRouteStatusKey).then((data) => {
					if (data == "A") {
						this.routeTo(this.bs.loadModulePath('srvy_mdl'), { id: ItemId, date: new Date().getTime() }, 'S');
					}
					else if (data == "E") {
						alert("Item has been expired");
						return false;
					}
				},
					(data) => {
						this.bs.log('info', 'Error in getting list');
					});

			}
			else {
				alert("Access denied - You are not authorized to access this notification.")
				return false;
			}
		}

		else if (itemType == "WBR") {
			let obj = { ItemId: ItemId, ItemType: itemType }
			if (actionName == "forward/VwWbmnrLS") {
				if (this.subMenuArray.indexOf('/learner/webinar/container') > -1) {
					this.systemAlertService.getNotificationAssignRouteWebinarStatusFromServer(obj, this.storageRouteStatusKey).then((data) => {
						if (data == "A") {
							this.routeTo(this.bs.loadModulePath('wbnr_mdl') , { id: ItemId,  date: new Date().getTime() }, 'W');
							//this.router.navigate(['/learner/webinar/container', { id: ItemId,  date: new Date().getTime() }]);
						}
						if (data == "E") {
							alert("This content has been expired.")
							return false;
						}
						if (data == "M") {
							alert("This content has been moved from here.")
							return false;
						}
					},
						(data) => {
							this.bs.log('info', 'Error in getting list');
						});

				}
			}
		}
		else if (itemType == "EL") {
			if (this.subMenuArray.indexOf('learner/external-learning/container') > -1) {
				paramObj = { DiscussionForumId: ItemId }
				this.routeTo(this.bs.loadModulePath('extrnl_lrng_mdl') + this.bs.getDirectPath('extrnl_dtls'), { id: ItemId }, 'E');
			}
			else {
				alert("Access denied - You are not authorized to access this notification.")
				return false;
			}
		}

		else if (itemType == "CRS-RMNDR") {
			if (this.subMenuArray.indexOf('/learner/taskList/container') > -1) {

				this.routeTo(this.bs.loadModulePath('tsk_mdl'), {}, 'M');
			}
			else {
				alert("Access denied - You are not authorized to access this notification.")
				return false;
			}
		}



		else if (itemType == "CRS" || itemType == "CRS-DF" || itemType == "CRS-EL" ) {

			let Obj = { ItemId: ItemId, ItemType: itemType }
			if (actionName == "forward/VwCrsLS") {
				if (this.subMenuArray.indexOf('/learner/taskList/container') > -1) {
					this.systemAlertService.getNotificationAssignRouteCourseStatusFromServer(Obj, this.storageRouteStatusKey).then((data) => {
						if (data == "A") {						
							if (itemType == "CRS-DF") {
								this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('crs_dtl'), { id: ItemId, tab: 'conversation', IsNodeClick: true }, 'M');
							}
							else {
								this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('crs_dtl'), { id: ItemId, IsNodeClick: true }, 'M');
							}						//this.router.navigate(['/learner/learning/container/course-detail', { id: ItemId }]);
						}
						if (data == "E") {
							alert("This content has been expired.")
							return false;
						}
						if (data == "M") {
							alert("This content has been moved from here.")
							return false;
						}
					},
						(data) => {
							this.bs.log('info', 'Error in getting list');
						});
				}
				else {
					alert("Access denied - You are not authorized to access this notification.")
					return false;
				}
			}

			else if (actionName == "forward/LrnngCntrSd") {
				if (this.subMenuArray.indexOf('/learner/course-catalog/container') > -1) {
					this.systemAlertService.getNotificationCatlougeRouteCourseStatusFromServer(Obj, this.storageRouteStatusKey).then((data) => {
						if (data == "A") {
							this.routeTo(this.bs.loadModulePath('crs_ctlg_mdl') + this.bs.getDirectPath('ctlg_dtl'), { id: ItemId }, 'A');
						}
						if (data == "E") {
							alert("This content has been expired.")
							return false;
						}
						if (data == "M") {
							alert("This content has been moved from here.")
							return false;
						}
					},
						(data) => {
							this.bs.log('info', 'Error in getting list');
						});
				}
				else {
					alert("Access denied - You are not authorized to access this notification.")
					return false;
				}
			}
			else {
				alert("Access denied - You are not authorized to access this notification.")
				return false;
			}
		}
		else if (itemType == "ILT-L" || itemType == "ILT-DF") {
			let Obj = { ItemId: ItemId }
			if (actionName == "forward/VwCrsLS") {
				if (this.subMenuArray.indexOf('/learner/taskList/container') > -1) {
					this.systemAlertService.getNotificationAssignRouteIltStatusFromServer(Obj, this.storageRouteStatusKey).then((data) => {
						if (data == "A") {
							if (itemType == "ILT-DF") {
								this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), { id: ItemId, tab: 'conversation' }, 'M');
							}
							else {
								this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), { id: ItemId }, 'M');
							}

						}
						if (data == "E") {
							alert("This content has been expired.")
							return false;
						}
						if (data == "M") {
							alert("This content has been moved from here.")
							return false;
						}
					},
						(data) => {
							this.bs.log('info', 'Error in getting list');
						});
				}
				else {
					alert("Access denied - You are not authorized to access this notification.")
					return false;
				}
			}
			else if (actionName == "forward/TrnngHstory") {
				if (this.subMenuArray.indexOf('/learner/taskList/container') > -1) {
					this.bs.isTrainingHistory = true;
					this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), { id: ItemId, IsNodeClick: false }, 'H');
				}
				else {
					alert("Access denied - You are not authorized to access this notification.")
					return false;
				}
			}
			else if (actionName == "forward/LrnngCntrSd") {
				if (this.subMenuArray.indexOf('/learner/course-catalog/container') > -1) {
					this.systemAlertService.getNotificationCatlougeRouteIltStatusFromServer(Obj, this.storageRouteStatusKey).then((data) => {
						if (data == "A") {
							this.routeTo(this.bs.loadModulePath('crs_ctlg_mdl') + this.bs.getDirectPath('ctlg_ilt_dtl'), { id: ItemId }, 'A');
						}
						if (data == "E") {
							alert("This content has been expired.")
							return false;
						}
						if (data == "M") {
							alert("This content has been moved from here.")
							return false;
						}
					},
						(data) => {
							this.bs.log('info', 'Error in getting list');
						});
				}
				else {
					alert("Access denied - You are not authorized to access this notification.")
					return false;
				}
			}
			else {
				alert("Access denied - You are not authorized to access this notification.")
				return false;
			}
		}
		else if (itemType == "ILT") {
			alert("Access denied - You are not authorized to access this notification.")
			return false;
		}
		else if (itemType == "GMF" && actionName != '') {
			if (this.subMenuArray.indexOf('/learner/leaderboard/container') > -1) {

				this.bs.notificationRoute = "true";
				this.routeTo(this.bs.loadModulePath('ldrbrd_mdl'), { id: ItemId }, 'G');
			}
			else {
				alert("Access denied - You are not authorized to access this notification.")
				return false;
			}
		}
		else if ((itemType == "GMF" && actionName == '') || itemType == "GMF1") {
			return false;
		}

		else if (itemType == "SPLRN") {
			let Obj = { ItemId: ItemId, ItemType: itemType }
			if (this.subMenuArray.indexOf('/learner/taskList/container') > -1) {
				this.systemAlertService.getNotificationAssignRouteCourseStatusFromServer(Obj, this.storageRouteStatusKey).then((data) => {
					if (data == "A") {
						this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('crs_dtl'), { id: ItemId, IsNodeClick: true }, 'M');
					}
					else {
						alert("Space learning program is either expired or not started yet.")
						return false;
					}

				},
					(data) => {
						this.bs.log('info', 'Error in getting list');
					});
			}
			else {
				alert("Access denied - You are not authorized to access this notification.")
				return false;
			}
		}
	};

	routeTo(path: string, params: object, menuItem: string) {
		$('.sub-header').show();
		$('body').removeClass('offsidebar-open');
		if(menuItem=='M' || menuItem=='H' ){
			this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
		}

		this.router.navigate([path, params]).then((res) => {
			console.log(res);
		});
		this.bs.activateMenuItem(menuItem);
	}
}
